import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.interface';
import { ICategory } from '../interfaces/category.interface';
import { IBrand } from '../interfaces/brand.interface';
import { IMeasurementSystem } from 'src/app/platform/measurement-system/interfaces/measurement-system.interface';
import { ITypeBalance } from '../interfaces/type-balance.interface';
import { IBalance } from '../interfaces/balance.interface';
import { IFavorite } from '../interfaces/favorite.interface';
import { environment } from 'src/environments/environment';
import { IFile } from '../interfaces/file.interface';


@Injectable({
  providedIn: 'root',
})
export class SharedService {

  constructor(private _http: HttpClient) {}

  getBrands(): Observable<ApiResponse<IBrand[]>> {
    return this._http.get<ApiResponse<IBrand[]>>(`${environment.apiUrl}/brands/id-name`);
  }

  getCategories(): Observable<ApiResponse<ICategory[]>> {
    return this._http.get<ApiResponse<ICategory[]>>(`${environment.apiUrl}/categories/id-name`);
  }

  getMeasurements(): Observable<ApiResponse<IMeasurementSystem[]>> {
    return this._http.get<ApiResponse<IMeasurementSystem[]>>(
      `${environment.apiUrl}/measurement-systems/id-name`
    );
  }

  getTypesBalances(): Observable<ApiResponse<ITypeBalance[]>> {
    return this._http.get<ApiResponse<ITypeBalance[]>>(
      `${environment.apiUrl}/balances/types-balances`
    );
  }

  registerMovement(balance: IBalance) : Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/balances/add`, balance);
  }

  addFavorite(productId: string): Observable<ApiResponse<IFavorite>> {
    return this._http.post<ApiResponse<IFavorite>>(
      `${environment.apiUrl}/users/add-favorite`,
      { product: productId }
    );
  }

  deleteFavorite(productId: string): Observable<ApiResponse<IFavorite>> {
    return this._http.delete<ApiResponse<IFavorite>>(
      `${environment.apiUrl}/users/delete-favorite/${productId}`
    );
  }

  getStockByProduct(productId: string,
    colorId: string,
    measurementSystemDetailId: string): Observable<ApiResponse<number>>{
      return this._http.get<ApiResponse<number>>(
        `${environment.apiUrl}/products/stock/${productId}?colorId=${colorId}&measurementSystemDetailId=${measurementSystemDetailId}`
      );
  }

  addImages(formData: FormData) : Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/images/add`, formData);
  }
  addImage(formData: FormData) : Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/images/addOne`, formData);
  }
  editImage(id: string, formData: FormData) : Observable<any> {
    return this._http.put<any>(`${environment.apiUrl}/images/edit/${id}`, formData);
  }

  editFile(id: string, file: IFile) : Observable<any> {
    return this._http.put<any>(`${environment.apiUrl}/files/edit/${id}`, file);
  }
}
